import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { EmployeeTimelogService } from 'src/app/services/employee-timelog/employee-timelog.service';
import { JobService } from 'src/app/services/job/job.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { TimeOffService } from 'src/app/services/time-off/time-off.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationModalComponent>, @Inject(MAT_DIALOG_DATA) public dialogData: any, private appService: AppService,
    private userService: UserManagementService, private spinner: NgxSpinnerService, private commonService: CommonService, private recruiterService: RecruiterService,
    private jobService: JobService, private timeOffReqService: TimeOffService, private empTimeLogService: EmployeeTimelogService, private recruterService:RecruiterService,
  ) { }
  ngOnInit(): void {

  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  onConfirm() {
    if (this.dialogData["content_type"] == "course practical") {
      this.changePracticalCourse()
    }
    if (this.dialogData["content_type"] == "employee type") {
      this.chnageEmpType()
    }
    else if (this.dialogData["content_type"] == "certificate access") {
      this.changeCertificateAccess()
    }
    else if (this.dialogData["content_type"] == "resubmit package") {
      this.resubmitPackage()
    }
    else if (this.dialogData["content_type"] == "wages") {
      this.changeWages()
    }
    else if (this.dialogData["content_type"] == "accept_reject") {
      if (this.dialogData["item_type"] == "role") {
        this.onRoleAcceptReject()
      }
      else if (this.dialogData["item_type"] == "company_accept") {
        this.onCompanyAcceptReject()
      }
      else if (this.dialogData["item_type"] == "visa_accept") {
        this.onVisaAcceptReject()
      }
      else if (this.dialogData["item_type"] == "timeoff_request") {
        this.onTimeOffRequest()
      }
      else if (this.dialogData["item_type"] == "time_clock_status") {
        this.onTimeClockStatusChange()
      }
    }
    else if (this.dialogData["content_type"] == "employee_status") {
      this.onEmployeeStatusChange()
    }

  }
  changePracticalCourse() {
    this.spinner.show()
    this.userService.changeCoursePractical(this.dialogData["dataObj"]).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success.msg) {
          this.appService.showToastMessage("success", success.msg);
        } else {
          this.appService.showToastMessage(
            "success",
            "Status Changed Successfully !!"
          );
        }

        this.dialogRef.close({ confirm_yes: true });
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  chnageEmpType() {

    let data = this.dialogData.dataObj

    this.recruterService.onChangeEmpSalried(data).subscribe((response: any) => {
      if (response.status == 200) {
        this.appService.showToastMessage(
          "success",
          "Status Changed Successfully !!"
        );
        this.dialogRef.close({ confirm_yes: true });
      }
    })
  }
  changeCertificateAccess() {
    this.spinner.show()
    this.userService.changeCourseManual(this.dialogData["dataObj"]).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success.msg) {
          this.appService.showToastMessage("success", success.msg);
        } else {
          this.appService.showToastMessage(
            "success",
            "Status Changed Successfully !!"
          );
        }
        this.dialogRef.close({ confirm_yes: true });
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  resubmitPackage() {
    this.dialogRef.close({ confirm_yes: true });
  }
  onRoleAcceptReject() {
    this.spinner.show()
    this.recruiterService.roleAccRej(this.dialogData["dataObj"]).subscribe({
      next: (success: any) => {
        this.onSuccessResponse(success)
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onVisaAcceptReject() {
    this.spinner.show()
    this.recruiterService.acceptRejectVisa(this.dialogData["dataObj"]).subscribe({
      next: (success: any) => {
        this.onSuccessResponse(success)
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onCompanyAcceptReject() {
    this.recruiterService.companyAccRej(this.dialogData["dataObj"]).subscribe({
      next: (success: any) => {
        this.onSuccessResponse(success)
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onSuccessResponse(success: any) {
    this.spinner.hide();
    if (success.msg) {
      this.appService.showToastMessage("success", success.msg);
    } else {
      this.appService.showToastMessage("success", "Status Changed Successfully !!"
      );
    }
    this.dialogRef.close({ confirm_yes: true });
  }
  changeWages() {
    this.dialogRef.close({ confirm_yes: true });
  }
  onCancel() {
    this.dialogRef.close();
  }
  onEmployeeStatusChange() {
    this.spinner.show()
    this.jobService.changeEmpStatus(this.dialogData["dataObj"]).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success.msg) {
          this.appService.showToastMessage("success", success.msg);
        } else {
          this.appService.showToastMessage(
            "success",
            "Status Changed Successfully !!"
          );
        }
        this.dialogRef.close({ confirm_yes: true });
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onTimeOffRequest() {
    this.spinner.show()
    this.timeOffReqService.approveRejectPoilicy(this.dialogData["dataObj"]).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success.msg) {
          this.appService.showToastMessage("success", success.msg);
        } else {
          this.appService.showToastMessage(
            "success",
            "Status Changed Successfully !!"
          );
        }
        this.dialogRef.close({ confirm_yes: true });
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onTimeClockStatusChange() {
    this.spinner.show()
    this.empTimeLogService.acceptRejectClock(this.dialogData["dataObj"]).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success.msg) {
          this.appService.showToastMessage("success", success.msg);
        } else {
          this.appService.showToastMessage(
            "success",
            "Status Changed Successfully !!"
          );
        }
        this.dialogRef.close({ confirm_yes: true });
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
}
